/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingOwnershipTransferDecision =
    (typeof BuildingOwnershipTransferDecision)[keyof typeof BuildingOwnershipTransferDecision];

export const BuildingOwnershipTransferDecision = {
    Accept: 1,
    Reject: 2,
} as const;
